
import Vue from 'vue'
export default Vue.extend({
    name: 'DogRegistrationFeeTable',
    props: {
        priceInfo: Array,
    }
})
